/*
 * @title App
 * @description Application entry point
 */

// import "jquery";

import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

//Vendor
import "Vendor/modernizr-custom.js";
import "Vendor/picturefill.js";
import "Vendor/swiper.js";
import "Vendor/jquery.lazy.js";
import "Vendor/jquery.lazy.picture.js";

// Utils
import "Utils/_tracking.js";
import "Utils/_getURLParms.js";
import "Utils/_custom-event.js";
import "Utils/_isonscreen.js";
import "Utils/video-modal.js";

// Polyfills
import "Utils/_closest.polyfill.js";
import "Utils/_matches.polyfill.js";

// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Modules
import swiperCarousel from "Modules/carousel/carousel";
import jaTeaserSlider from "Modules/ja-teaser/ja-teaser-slider";
import swiperJa from "Modules/ja-slider/ja-slider";
import swiperTimetravel from "Modules/timetravel-slider/timetravel-slider";
import swiperRecipes from "Modules/recipes-slider/recipes-slider";
// import navbar from 'Modules/navbar/navbar';
import searchOverlay from "Modules/search-overlay/search-overlay";
import "Modules/flip-cards/flip-cards";
import gsapScolling from "Modules/gsap-scrolling/gsap-scrolling";
import "Modules/lazy/lazy";

// Components
// import collapse from 'Components/collapse.js';
import smoothScroll from "Components/smooth-scroll";
import toggleElement from "Components/toggle-element";

document.addEventListener("DOMContentLoaded", function() {
    // Modules
    swiperCarousel();
    jaTeaserSlider();
    swiperJa();
    swiperTimetravel();
    swiperRecipes();
    // navbar();
    searchOverlay();
    searchOverlay();
    gsapScolling();

    // Components
    // collapse();
    smoothScroll();
    toggleElement();
});
